import { WAREHOUSE_OPERATIONS } from './warehouse_operations';

// The operation keys come along because a document is edited from the register
// through its original operation dialog.
export const WarehouseDocuments = {
  en: {
    ...WAREHOUSE_OPERATIONS.en,
    Waybills: 'Waybills',
    Deleted: 'Deleted',
    Period: 'Period',
    Type: 'Type',
    'Waybill №': 'Waybill №',
    Supplier: 'Supplier',
    Warehouse: 'Warehouse',
    Date: 'Date',
    Time: 'Time',
    From: 'From',
    To: 'To',
    Note: 'Note',
    Sum: 'Sum',
    Paid: 'Paid',
    'On consignment': 'On consignment',
    View: 'View',
    period_all: 'All',
    period_year: 'Year',
    period_quarter: 'Quarter',
    period_month: 'Month',
    period_week: 'Week',
    period_day: 'Day',
    doc_receipt: 'Goods receipt',
    doc_transfer: 'Transfer between warehouses',
    doc_replacement: 'Product replacement',
    doc_write_off: 'Write-off',
    doc_supplier_return: 'Return to supplier',
    doc_inventory: 'Inventory',
    'Export CSV': 'Export CSV',
    SKU: 'SKU',
    Product: 'Product',
    Packages: 'Packages',
    Quantity: 'Quantity',
    Discount: 'Discount',
    'Transport costs': 'Transport costs',
    'Total sum': 'Total sum',
    g: 'g',
    kg: 'kg',
    l: 'l',
    m: 'm',
    ml: 'ml',
    unit: 'pcs',
    cm: 'cm',
  },
  uk: {
    ...WAREHOUSE_OPERATIONS.uk,
    Waybills: 'Накладні',
    Deleted: 'Видалено',
    Period: 'Період',
    Type: 'Тип',
    'Waybill №': 'Номер накладної',
    Supplier: 'Постачальник',
    Warehouse: 'Склад',
    Date: 'Дата накладної',
    Time: 'Час',
    From: 'З',
    To: 'До',
    Note: 'Примітка',
    Sum: 'Сума',
    Paid: 'Оплачено',
    'On consignment': 'Під реалізацію',
    View: 'Переглянути',
    period_all: 'Все',
    period_year: 'Рік',
    period_quarter: 'Квартал',
    period_month: 'Місяць',
    period_week: 'Тиждень',
    period_day: 'День',
    doc_receipt: 'Прихід товарів',
    doc_transfer: 'Переміщення між складами',
    doc_replacement: 'Заміна товару',
    doc_write_off: 'Списання товарів',
    doc_supplier_return: 'Повернення постачальнику',
    doc_inventory: 'Інвентаризація',
    'Export CSV': 'Експорт у CSV',
    SKU: 'Артикул',
    Product: 'Товар',
    Packages: 'Упаковки',
    Quantity: 'Кількість',
    Discount: 'Знижка',
    'Transport costs': 'Транспортні витрати',
    'Total sum': 'Загальна сума',
    g: 'г',
    kg: 'кг',
    l: 'л',
    m: 'м',
    ml: 'мл',
    unit: 'шт',
    cm: 'см',
  },
};
